// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tags_tag__bj0Fg","remove":"Tags_remove__Didcq","tagActive":"Tags_tagActive__HX4bx"};